import type { BusinessUnit } from '@backend/lib-l10n';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { getCanonicalUrl } from '~/utils/canonicalUrl';

export const useCanonicalUrl = (businessUnit: BusinessUnit, page?: number): string => {
  const { asPath } = useRouter();

  return useMemo(() => getCanonicalUrl(asPath, businessUnit, page), [asPath, businessUnit, page]);
};
